import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
const _hoisted_2 = { class: "columns is-variable is-5" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "column is-narrow" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Georgia Benefits"),
    /*#__PURE__*/ _createElementVNode("h3", null, "Requests for Benefits")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_5 = { class: "column is-narrow pt-3" };
const _hoisted_6 = { class: "tabs is-toggle is-small mb-3" };
const _hoisted_7 = { style: { "justify-content": "right" } };
const _hoisted_8 = { class: "field" };
const _hoisted_9 = { class: "control" };
const _hoisted_10 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "40%" } }, "Citizen Name", -1);
const _hoisted_12 = { key: 0 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("th", null, "Created", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("th", null, "Status", -1);
const _hoisted_15 = { key: 0 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "Select a partner", -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { key: 2 };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { style: { "vertical-align": "middle" } };
const _hoisted_24 = { class: "adaptiveLabel" };
const _hoisted_25 = { style: { "vertical-align": "middle" } };
const _hoisted_26 = { class: "adaptiveLabel" };
const _hoisted_27 = { key: 4 };
const _hoisted_28 = {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
};
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { formatDateShort, notifyNetworkError } from "@/core/utils";
import { RequestStatus, requestStatusLabels } from "@/features/applications/model";
import { computed, ref, watch } from "vue";
import { apiGeorgiaBenefits } from "./api";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
import { User, Core } from "@minicity/core";
// Fetch birth records from API
const LIMIT_SIZE = 150;
export default /*#__PURE__*/ _defineComponent({
    __name: 'GeorgiaBenefitsListingPanel',
    setup(__props) {
        const georgiaBenefits = useAsync();
        if (sessionState.session) {
            switch (sessionState.session.user.role) {
                case User.Role.NETWORK_ADMIN:
                    georgiaBenefits.fetch(apiGeorgiaBenefits.getForNetwork()).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                case User.Role.PARTNER_ADMIN:
                    georgiaBenefits.fetch(apiGeorgiaBenefits.getForPartner(sessionState.session.partnerId)).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                case User.Role.PARTNER_USER:
                    georgiaBenefits.fetch(apiGeorgiaBenefits.getForCaseworker(sessionState.session.partnerId, sessionState.session.user.id)).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                default:
                    console.error("Unexpected user type");
                    break;
            }
        }
        const partnerId = ref(null);
        watch(partnerId, () => {
            georgiaBenefits.fetch(partnerId.value ? apiGeorgiaBenefits.getForPartner(partnerId.value) : apiGeorgiaBenefits.getForNetwork()).catch(err => { notifyNetworkError("Failed to load applications", err); });
        });
        // Search / category filtering
        const showAll = ref(false);
        const { searchQuery, filtered: filteredApplications, limited: limitedApplications } = useFilterForAsync(georgiaBenefits, (appl) => `${appl.citizen.displayName} ${appl.id}`, LIMIT_SIZE);
        const activeCategory = ref("ALL");
        const georgiaBenefitsToDisplay = computed(() => {
            return (showAll.value ? filteredApplications : limitedApplications).value.filter(georgiaBenefits => {
                switch (activeCategory.value) {
                    case "ALL": return true;
                    case "NEW": return [RequestStatus.NEW].includes(georgiaBenefits.status);
                    case "NOTARY_OR_DOCS_REQUIRED": return [RequestStatus.NOTARY_REQUIRED, RequestStatus.DOCS_REQUIRED].includes(georgiaBenefits.status);
                    case "READY_TO_SUBMIT": return [RequestStatus.READY_TO_SUBMIT].includes(georgiaBenefits.status);
                    case "SUBMITTED": return [RequestStatus.SUBMITTED].includes(georgiaBenefits.status);
                    case "REJECTED": return [RequestStatus.REJECTED].includes(georgiaBenefits.status);
                    case "APPROVED": return [RequestStatus.APPROVED].includes(georgiaBenefits.status);
                    case "CANCELLED": return [RequestStatus.CANCELLED].includes(georgiaBenefits.status);
                }
            });
        });
        return (_ctx, _cache) => {
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_CitizenBadge = _resolveComponent("CitizenBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            return (_unref(isFeatureEnabled)('GEORGIA_DFCS_BENEFITS'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createBlock(PartnerSelectField, {
                                key: 0,
                                modelValue: partnerId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((partnerId).value = $event)),
                                allowSelectAll: ""
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("ul", _hoisted_7, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ALL' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (activeCategory.value = 'ALL'))
                                        }, "All")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'NEW' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[2] || (_cache[2] = ($event) => (activeCategory.value = 'NEW'))
                                        }, "New")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'NOTARY_OR_DOCS_REQUIRED' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[3] || (_cache[3] = ($event) => (activeCategory.value = 'NOTARY_OR_DOCS_REQUIRED'))
                                        }, "Docs Required")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'READY_TO_SUBMIT' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[4] || (_cache[4] = ($event) => (activeCategory.value = 'READY_TO_SUBMIT'))
                                        }, "Ready To Submit")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'SUBMITTED' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[5] || (_cache[5] = ($event) => (activeCategory.value = 'SUBMITTED'))
                                        }, "Submitted")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'REJECTED' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[6] || (_cache[6] = ($event) => (activeCategory.value = 'REJECTED'))
                                        }, "Rejected")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'APPROVED' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[7] || (_cache[7] = ($event) => (activeCategory.value = 'APPROVED'))
                                        }, "Approved")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'CANCELLED' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[8] || (_cache[8] = ($event) => (activeCategory.value = 'CANCELLED'))
                                        }, "Cancelled")
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "input",
                                        type: "text",
                                        placeholder: "Search",
                                        autofocus: "",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                    }, null, 512), [
                                        [_vModelText, _unref(searchQuery)]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("table", _hoisted_10, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_11,
                                (_unref(isNetworkAdmin)())
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Partner"))
                                    : _createCommentVNode("", true),
                                _hoisted_13,
                                _hoisted_14
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_unref(isNetworkAdmin)() && partnerId.value == 'none')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                                : (_unref(georgiaBenefits).status == 'loading')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                        _createVNode(_component_LoadingTableRow)
                                    ]))
                                    : (georgiaBenefitsToDisplay.value.length == 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(georgiaBenefitsToDisplay.value, (georgiaBenefit) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: georgiaBenefit.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/georgiaBenefits/${georgiaBenefit.id}`,
                                                        class: "horizontal"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_CitizenBadge, {
                                                                citizen: georgiaBenefit.citizen
                                                            }, null, 8, ["citizen"]),
                                                            _createVNode(_component_OpenTasksIndicator, {
                                                                entityType: _unref(Core).EntityType['Georgia DFCS Benefits'],
                                                                entityId: georgiaBenefit.id
                                                            }, null, 8, ["entityType", "entityId"])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                (_unref(isNetworkAdmin)())
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/georgiaBenefits/${georgiaBenefit.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_PartnerBadge, {
                                                                    partner: georgiaBenefit.citizen.assignedCareProvider,
                                                                    noLink: ""
                                                                }, null, 8, ["partner"])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("td", _hoisted_23, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/georgiaBenefits/${georgiaBenefit.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(formatDateShort)(georgiaBenefit.createdAt)), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", _hoisted_25, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/georgiaBenefits/${georgiaBenefit.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(requestStatusLabels)[georgiaBenefit.status]), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ])
                                            ]));
                                        }), 128)),
                            (_unref(georgiaBenefits).status == 'ready' && _unref(filteredApplications).length > LIMIT_SIZE && !showAll.value)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                                    _createElementVNode("td", _hoisted_28, [
                                        _createElementVNode("a", {
                                            onClick: _cache[10] || (_cache[10] = ($event) => (showAll.value = true))
                                        }, "Show All (" + _toDisplayString(_unref(filteredApplications).length - LIMIT_SIZE) + " more)", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
